import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["download", "generate", "label", "spinner", "status"]

  connect() {
    this.pollTimer = null
  }

  disconnect() {
    this.stopPolling()
  }

  generate(event) {
    event.preventDefault()
    if (this.generateTarget.classList.contains("disabled")) return

    this.setPreparing()

    fetch(this.data.get("generateUrl"), {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": this.csrfToken()
      },
      credentials: "same-origin"
    })
      .then((response) => response.json())
      .then((data) => this.update(data))
      .then(() => this.startPolling())
      .catch(() => this.setError())
  }

  startPolling() {
    this.stopPolling()
    this.pollTimer = window.setInterval(() => this.fetchStatus(), this.pollInterval())
    this.fetchStatus()
  }

  stopPolling() {
    if (!this.pollTimer) return

    window.clearInterval(this.pollTimer)
    this.pollTimer = null
  }

  fetchStatus() {
    fetch(this.data.get("statusUrl"), {
      headers: { "Accept": "application/json" },
      credentials: "same-origin"
    })
      .then((response) => response.json())
      .then((data) => this.update(data))
      .catch(() => this.setError())
  }

  update(data) {
    if (data.ready) {
      this.setReady(data.download_url, data.unavailable_message)
      this.stopPolling()
    } else {
      this.setPreparing()
    }
  }

  setPreparing() {
    this.downloadTarget.classList.add("d-none")
    this.generateTarget.classList.add("disabled")
    this.generateTarget.disabled = true
    this.generateTarget.setAttribute("aria-disabled", "true")
    this.generateTarget.setAttribute("aria-busy", "true")
    this.spinnerTarget.classList.remove("d-none")
    this.setLabel("Gatavo pielikumu ZIP...")
    this.statusTarget.classList.add("d-none")
  }

  setReady(downloadUrl, unavailableMessage) {
    this.downloadTarget.href = downloadUrl || this.data.get("downloadUrl")
    this.downloadTarget.classList.remove("d-none")
    this.generateTarget.classList.remove("disabled")
    this.generateTarget.disabled = false
    this.generateTarget.removeAttribute("aria-disabled")
    this.generateTarget.removeAttribute("aria-busy")
    this.generateTarget.classList.remove("btn-info")
    this.generateTarget.classList.add("btn-secondary")
    this.spinnerTarget.classList.add("d-none")
    this.setLabel("Atjaunot pielikumu ZIP")
    this.statusTarget.classList.toggle("d-none", !unavailableMessage)
    this.statusTarget.textContent = unavailableMessage || ""
  }

  setError() {
    this.generateTarget.classList.remove("disabled")
    this.generateTarget.disabled = false
    this.generateTarget.removeAttribute("aria-disabled")
    this.generateTarget.removeAttribute("aria-busy")
    this.spinnerTarget.classList.add("d-none")
    this.setLabel("Mēģināt vēlreiz")
    this.statusTarget.classList.remove("d-none")
    this.statusTarget.textContent = "Neizdevās pārbaudīt ZIP statusu."
    this.stopPolling()
  }

  pollInterval() {
    return parseInt(this.data.get("pollInterval") || "3000", 10)
  }

  setLabel(label) {
    this.labelTarget.textContent = label
    this.generateTarget.setAttribute("aria-label", label)
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta && meta.content
  }
}
